import {
  Address,
  StrapiMedia,
  StrapiProjectDetails,
  StrapiPromoteQuestData,
  StrapiRepeatableComponent,
  StrapiSingleComponent,
} from '@types'
import { ProjectStatus } from '@contracts'

export type StrapiProjectData = {
  betaOnly: boolean
  createdAt: string
  distributionPercentInFund?: number
  events: Array<ProjectEvent>
  network: Array<{ id: number; name: string }>
  notes: Array<{ id: number; note: string }>
  productCategory: Array<{ id: number; name: string }>
  projectAddress: Address
  projectDetails: StrapiSingleComponent<StrapiProjectDetails>
  projectId: string
  projectLogo: StrapiSingleComponent<StrapiMedia>
  projectName: string
  projectSummary: string
  projectUrlId: string
  promoCompletionBonus: string | null
  promoCompletionBonusAmount: number | null
  publishedAt: string
  stage: ProjectStatus
  tokenSymbol: string
  updatedAt: string
  tgeDate: string
  promoQuestsV2: StrapiRepeatableComponent<StrapiPromoteQuestData>
  rewardsV2ProjectStatus: 'Draft' | 'Active' | 'Completed' | 'Disabled'
  startTime: string | null
  endTime: string | null
}

export enum ProjectEventType {
  event = 'event',
  vote = 'vote',
}

export type ProjectEvent = {
  timestamp: string
  title: string
  description: string
  type: ProjectEventType
}
